import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { SegurosRestService } from '../omni-rest/seguros/seguros-rest.service';
@Injectable()
export class SegurosService {
  constructor(
    private segurosRestService: SegurosRestService
  ) { }
  clearCotacaoProposta(idProposta: string): Observable<any> {
    return this.segurosRestService.delete(`suhai/cotacao/${idProposta}/clear`);
  }
  createCotacao(idProposta: string): Observable<any> {
    return this.segurosRestService.post(`suhai/criar/cotacao/${idProposta}`, {});
  }
}
